import * as _ from 'lodash';
import Sortable from 'sortablejs';
import VueSlickgrid from './VueSlickgrid.vue';
import VueSlickgridColumnSelector from './VueSlickgridColumnSelector.vue';
export { VueSlickgrid, VueSlickgridColumnSelector };

_.set(window, 'Sortable', Sortable);

export * from './extensions';
export * from './columns';
export * from './formatters';
export * from './LocalData';
